<template>
  <div
    class="d-flex base-flex"
    :class="classes"
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BaseComponent from '../BaseComponent/BaseComponent.vue';

export default defineComponent({
  name: 'BaseFlex',
  extends: BaseComponent,
});
</script>

<style lang="scss" scoped>
@if mixin-exists("ThemeBaseFlex") {
  @include ThemeBaseFlex;
}
</style>
